<template>
  <b-card style="padding:40px;">
    <h5><b>STOCKOUT (PREVIEW)</b></h5>
    <hr />
    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Full Name </label>
          <b-form-input
            v-model="form.name"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role_code`">Date</label>
          <b-form-input
            v-model="form.date"
            :id="`input-role_code`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role_code`">Roles</label>
          <b-form-input
            v-model="form.role"
            :id="`input-role_code`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Outlet Category</label>
          <b-form-input
            v-model="form.outlet_cat_name"
            :id="`input-role`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4" v-if="form.suboutlet_cat">
        <b-form-group>
          <label :for="`input-role_code`">Sub Outlet Category</label>
          <b-form-input
            v-model="form.suboutlet_cat_name"
            :id="`input-role_code`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4" v-if="form.typeoutlet">
        <b-form-group>
          <label :for="`input-size`">Outlet Category Type</label>
          <b-form-input
            v-model="form.typeoutlet_name"
            id="input-horizontal"
            type="text"
            required
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4" v-if="form.idno">
        <b-form-group>
          <label :for="`input-size`">Outlet ID Number</label>
          <b-form-input
            v-model="form.idno"
            id="input-horizontal"
            type="text"
            required
            disabled
          ></b-form-input>
        </b-form-group>
      </b-col>

      <b-col md="4">
        <b-form-group>
          <label :for="`input-role_code`">Outlet Name</label>
          <b-form-input
            v-model="form.outlet_name"
            :id="`input-role_code`"
            :type="`text`"
            readonly
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col md="4">
        <b-form-group>
          <label :for="`input-role`">Chiller</label>
          <b-form-radio-group
            v-model="form.chiller"
            :options="chiller"
            plain
            name="plain-inline"
            disabled
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>

    <div class="accordion" role="tablist">
      <b-card no-body class="mb-1">
        <b-card-header header-tag="header" class="p-1" role="tab">
          <b-button block v-b-toggle.accordion-1 variant="info"
            >Outlet Detail</b-button
          >
        </b-card-header>
        <b-collapse id="accordion-1" accordion="my-accordion" role="tabpanel">
          <b-card-body>
            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label :for="`input-role`">Company Name</label>
                  <b-form-input
                    v-model="form.compName"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label :for="`input-role`">Account No.</label>
                  <b-form-input
                    v-model="form.accno"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label :for="`input-role`">Credit Term</label>
                  <b-form-input
                    v-model="form.credit_terms"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <b-form-group>
                  <label :for="`input-role`">Fax No.</label>
                  <b-form-input
                    v-model="form.faxno"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="4">
                <b-form-group>
                  <label :for="`input-role`">Tel No.</label>
                  <b-form-input
                    v-model="form.telno"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label :for="`input-role`">Address 1</label>
                  <b-form-input
                    v-model="form.add1"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label :for="`input-role`">Address 2</label>
                  <b-form-input
                    v-model="form.add2"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label :for="`input-role`">Address 3</label>
                  <b-form-input
                    v-model="form.add3"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label :for="`input-role`">Billing Address 1</label>
                  <b-form-input
                    v-model="form.billAdd1"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label :for="`input-role`">Billing Address 2</label>
                  <b-form-input
                    v-model="form.billAdd2"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label :for="`input-role`">Billing Address 3</label>
                  <b-form-input
                    v-model="form.billAdd3"
                    type="text"
                    class="input-new"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="12">
                <b-form-group>
                  <label :for="`input-role`">Notes</label>
                  <b-form-textarea
                    v-model="form.notes"
                    class="input-new"
                    rows="3"
                    max-rows="6"
                    disabled
                  ></b-form-textarea>
                </b-form-group>
              </b-col>
            </b-row>
          </b-card-body>
        </b-collapse>
      </b-card>
    </div>

    <br />
    <TableStockoutPreview :fields="fields" :items="items" :grand="grandP" />
    <b-row align="right">
      <b-col>
        <b-button variant="primary" size="sm" @click="onClickBack">
          BACK </b-button
        >&nbsp;&nbsp;&nbsp;
        <b-button variant="primary" size="sm" @click="onClickSubmit"
          >SUBMIT</b-button
        >
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import TableStockoutPreview from "@/table/user/stockout/TableStockoutPreview";
import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import Failed from "@/pages/Notifications/Failed";
import moment from "moment";

export default {
  data() {
    return {
      category: "",
      id: "",
      items: [],
      form: {
        id: "",
        category: "",
        name: "",
        date: "",
        company: "",
        role: "",
        outlet_cat: "",
        outlet_name: "",
        pro_cat: "",
        type: "",
        chiller: "",
        suboutlet_cat: "",
        typeoutlet: "",
        faxno: "",
        telno: "",
        add1: "",
        add2: "",
        add3: "",
        billAdd1: "",
        billAdd2: "",
        billAdd3: "",
        compName: "",
        credit_terms: "",
        accno: "",
        notes: ""
      },

      chiller: [
        { value: "1", text: "Yes" },
        { value: "0", text: "No" }
      ],

      grandP: "0",

      temp_data: "",

      fields: [
        {
          label: "No",
          key: "no",
          sortable: false
        },
        {
          label: "Product Name",
          key: "product_name",
          sortable: true
        },
        {
          label: "Quantity",
          key: "quantity",
          sortable: true
        },
        {
          label: "Quantity Type",
          key: "qtyType",
          sortable: true
        },
        {
          label: "Price",
          key: "price",
          sortable: false
        },
        {
          label: "Total Price (RM)",
          key: "totalprice",
          sortable: false
        }
      ]
    };
  },
  created() {
    // let temp = localStorage.getItem("data_stockout");

    // let data = JSON.parse(temp);
    // localStorage.removeItem("data_stockout");

    // this.temp_data = data;
    // this.items = data.items;

    this.showStockout();
    this.getUser();
  },
  methods: {
    showStockout() {
      this.$store
        .dispatch("showStockout", {
          stock_id: this.$route.query.id
        })
        .then(res => {
          let price = 0;
          this.items = [];
          if (res.data.response.code === 100) {
            let outletName;
            if (res.data.data.outlet !== null) {
              outletName = res.data.data.outlet.name;
            }

            if (res.data.data.suboutlet.name) {
              this.form.suboutlet_cat_name = res.data.data.suboutlet.name;
            }
            if (res.data.data.suboutlettype.name) {
              this.form.typeoutlet_name = res.data.data.suboutlettype.name;
            }

            this.form.id = this.$route.query.id;
            this.form.idno = res.data.data.idno;
            this.form.name = res.data.data.userdetails.name;
            this.form.date = moment(res.data.data.date).format("DD/MM/YYYY");
            this.form.comp_name = res.data.data.userdetails.company;
            this.form.role = res.data.data.userdetails.role_details.desc;
            this.form.outlet_cat_name = outletName;
            this.form.chiller = res.data.data.chiller;
            this.form.outlet_name = res.data.data.outlethistory.outlet_name;
            this.form.suboutlet_cat = res.data.data.sub_outlet_id;
            this.form.typeoutlet = res.data.data.sub_outlet_type;
            this.form.faxno = res.data.data.outlethistory.faxno;
            this.form.telno = res.data.data.outlethistory.telno;
            this.form.add1 = res.data.data.outlethistory.add1;
            this.form.add2 = res.data.data.outlethistory.add2;
            this.form.add3 = res.data.data.outlethistory.add3;
            this.form.notes = res.data.data.outlethistory.notes;
            this.form.billAdd1 = res.data.data.company_add1;
            this.form.billAdd2 = res.data.data.company_add2;
            this.form.billAdd3 = res.data.data.company_add3;
            this.form.compName = res.data.data.company_name;
            this.form.credit_terms = res.data.data.credit_terms;
            this.form.accno = res.data.data.accno;

            res.data.data.pro_stock.forEach(element => {
              let defPrice = parseFloat(element.total_price_pu);
              price += defPrice;
              this.items.push({
                product_name: element.product.name,
                sku: element.product_id,
                quantity: element.quantity,
                qtyType: element.quantity_type === 1 ? "Pcs" : "Ctn",
                price: element.price,
                totalprice: element.total_price_pu
              });
            });
            this.grandP = price;
          }
        });
    },
    onClickBack() {
      localStorage.setItem("data_stockout", JSON.stringify(this.temp_data));

      this.$router.push({
        path: `stockout_user_create?stockid=${this.form.id}&type=update&from=update`
      });
    },
    onClickSubmit() {
      this.$store
        .dispatch("updateStatusMF", {
          category: 1,
          id: this.form.id
        })
        .then(res => {
          if (res.data.response.code === 1) {
            localStorage.removeItem("data_stockout");
            this.$notify({
              component: NotificationTemplate,
              icon: "ti-check",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "success"
            });
            this.$router.push({
              path: `stockout_user_view?id=${this.form.id}&cat=1&from=created`
            });
          } else {
            this.$notify({
              component: Failed,
              icon: "ti-close",
              horizontalAlign: "right",
              verticalAlign: "top",
              type: "danger"
            });
          }
        });
    },

    getUser() {
      this.$store
        .dispatch("showUser", {
          user_id: this.$store.getters.getUser_id
        })
        .then(res => {
          if (res.data.response && res.data.response.code === 100) {
            this.form.name = res.data.data.name;
            this.form.company = res.data.data.company;
            this.form.role = res.data.data.role_details.desc;
          }
        });
    }
  },
  components: {
    TableStockoutPreview
  }
};
</script>
<style lang="css" scoped></style>
